import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
const gtmId = 'GTM-WMP9C5Q5';
const gtmWindow = window as Window & {
  dataLayer?: Array<Record<string, unknown>>;
};
if (!document.querySelector(`script[data-gtm-id="${gtmId}"]`)) {
  gtmWindow.dataLayer = gtmWindow.dataLayer || [];
  gtmWindow.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js'
  });
  const gtmScript = document.createElement('script');
  gtmScript.async = true;
  gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
  gtmScript.dataset.gtmId = gtmId;
  document.head.insertBefore(gtmScript, document.head.firstChild);
}
render(<App data-id="element-254" />, document.getElementById('root'));